<template>
  <v-app class="my-application">
    <EncabezadoPagina />
    <v-main class="imagenFondo">
      <router-view />
    </v-main>
    <PiePagina mensaje="¿Necesita ayuda?" />
  </v-app>
</template>

<script>
import EncabezadoPagina from "@/components/EncabezadoPagina";
import PiePagina from "@/components/PiePagina";
import { USER_REQUEST } from "@/store/store";
export default {
  name: "App",
  components: {
    EncabezadoPagina,
    PiePagina
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  },
  created: function() {
    // Leer valo variable.
    // url = getComputedStyle(document.documentElement).getPropertyValue("--my-background-image-url");
    if (this.isAuthenticated) {
      const Nombre = localStorage.getItem("user-name");
      this.$store.dispatch(USER_REQUEST, { Nombre });
    }
    document.documentElement.style.setProperty(
      "--my-background-image-url",
      "url(" + this.$store.getters.APP_BACKGROUND_IMAGE_URL + ")"
    );
  }
};
</script>

<style>
:root {
  --my-background-image-url: "";
}

.imagenFondo {
  background-color: black;
  background-image: var(--my-background-image-url);
  background-size: cover;
}

.my-application .v-input,
.my-application .v-label {
  font-size: 1em;
}

/*mGuy: v-select y v-autocomplete active*/
.theme--light.v-list .v-list__tile--link:hover,
.theme--light.v-list .v-list__tile--highlighted,
.theme--light.v-list .v-list__group__header:hover {
  color: #fff;
  background-color: grey;
}
</style>
